<template>
    <div class="top-menu-box" :class="{'show':newShow}">
        <div class="title">
            <span class="img-box iconfont icon-caidan" @click="handleTopMenusIsShow"></span>
            <p class="name">{{title}}</p>
        </div>
        <div class="menu-list">
            <p
                class="item"
                v-for="(item,index) in menus"
                :key="index"
                @click="handleSelectType(item)"
            >{{item.name}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "top-menus",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            }
        },
        watch: {
            show(vl){this.newShow = vl}
        },
        data(){
            return {
                newShow: this.show,
                menus: [
                    {id: 1, name: '我的课件'},
                    {id: 2, name: '新建课件'},
                    {id: 3, name: '使用帮助'},
                ]
            }
        },
        methods: {
            // 顶部菜单是否展示
            handleTopMenusIsShow(){
                this.newShow = !this.newShow
                this.$emit('update:show',this.newShow)
            },
            // 选中类别
            handleSelectType(item){
                console.log('select-type', item, this.$route.query)
                this.newShow = false
                switch (item.id) {
                    case 1:
                        this.$RouteUtil.template({...this.$route.query})
                        break;
                    case 2: {
                        let obj = {
                            school_id: this.$store.state.initConfig.school_id,
                            category_id: this.$store.state.initConfig.category_id
                        }
                        if (this.$store.state.initConfig.is_template) obj['is_template'] = true
                        if (this.$store.state.initConfig.is_shop) obj['is_shop'] = true
                        this.$RouteUtil.main({...this.$route.query, ...obj, id: ''})
                        window.location.reload()
                        break;
                    }
                    case 3:
                        break;
                    default:
                }
                this.$emit('update:show',this.newShow)
            }
        }
    }
</script>

<style lang="scss" scoped>
.top-menu-box{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 0px;
    height: 100vh;
    background-color: rgba(0,0,0,.8);
    transition: width .2s linear;
    overflow: hidden;

    &.show{
        width: 255px;
    }

    .title {
        display: flex;
        flex-direction: row;
        width: 255px;
        align-items: center;
        box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.17);
        border-bottom: 1px solid #585454;

        .img-box {
            margin-left: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 34px;
            color: white;
        }

        .name {
            font-size: 16px;
            display: flex;
            flex: 1;
            font-weight: bold;
            color: white;
            line-height: 60px;
            justify-content: center;
            margin-right: 23px;
        }
    }
    .menu-list{
        display: flex;
        flex-direction: column;
        max-height: calc(100vh - 61px);
        overflow-y: auto;

        .item{
            font-size: 14px;
            color: white;
            padding-left: 12px;
            padding-right: 12px;
            border-bottom: 1px solid #585454;
            cursor: pointer;
        }
    }
}
</style>
